import "./App.css";
import "./Common.css";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import DashboardLayout from "./pages/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import ScrollToTop from "./components/ScrollToTop";
import LoanProduct from "./pages/LoanProduct";
import SingleLoanProduct from "./pages/SingleProduct";
import Profile from "./pages/Profile/Profile";
import { useQuery } from "react-query";
import { useEffect, useState, createContext } from "react";
import PageLoader from "./components/PageLoader";
import axios from "./axios/axios";
import LoanAppl from "./pages/LoanApplication";
import LoanApply from "./pages/LoanApplication/LoanApply";
import RemoteSign from "./pages/LoanApplication/RemoteSign";
import CaseList from "./pages/LoanApplicationCases/CaseList";
import CaseDetails from "./pages/LoanApplicationCases/CaseDetails";
import EditDetails from "./pages/LoanApplicationCases/EditDetails";
import NotificationLayout from "./pages/Notification";
import FlooringNotificationLayout from "./pages/FlooringNotification";
import ViewApplicationForm from "./pages/LoanApplicationCases/ViewApplicationForm";
import CaseSumary from "./pages/LoanApplicationCases/CaseSumary";
import { update } from "./redux/slice/settingsSlice";
import { useDispatch } from "react-redux";
import UserAccounts from "./pages/UserAccounts";
import UserRoles from "./pages/UserRoles";
import ProtectedRoute from "./common/ProtectedRoute";
import NoPermission from "./pages/NoPermission";
import FlooringCases from "./pages/FlooringCases";
import FlooringRates from "./pages/FlooringRates";
import FlooringVouchers from "./pages/FlooringVouchers";
import NewFlooringApplication from "./pages/NewFlooringApplication";
import ViewFlooringCases from "./pages/FlooringCases/ViewFlooringCases";
import PreviewAAF from "./pages/FlooringCases/View/PreviewAAF";
import CaseSummary from "./pages/FlooringCases/View/CaseSummary";
import ViewSOA from "./pages/FlooringCases/View/ViewSOA";
import CaseSummaryInfo from "./pages/LoanApplicationCases/CaseSummaryInfo";
import ResetPassword from "./pages/ResetPassword";
import TokenHandler from "./components/TokenHandler/TokenHandler";
import DealerCommisionReport from "./pages/DealerCommisionReport";
import InvoiceGenerate from "./pages/LoanApplicationCases/InvoiceGenerate";
import AgentChart from "./pages/LoanApplicationCases/AgentChart";

export const AuthenticationContext = createContext(null);

function App() {
  const dispatch = useDispatch();
  const tokenId = localStorage.getItem("dealerModuleToken");
  const [authData, setAuthData] = useState(null);
  const [compLoad, setCompLoad] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [flooringCount, setFlooringCount] = useState(0);

  const { isLoading } = useQuery(
    "auth",
    async () => {
      try {
        const resp = await axios.get("/profile/info", {
          headers: {
            Authorization: `Bearer ${tokenId}`,
          },
        });
        // console.log('resp====',resp)
        setAuthData(resp?.data?.data);
        return resp?.data?.data;
      } catch (error) {
        console.log('error====', error)
        localStorage.removeItem("dealerModuleToken");
        window.location.reload()
      }

    },
    {
      refetchOnWindowFocus: false,
      enabled: !authData && tokenId !== null,
    }
  );

  useEffect(() => {
    async function setSettings() {
      let res = await axios.get("/settings");
      dispatch(update(res.data.data));
    }
    setSettings();
  }, []);

  return (
    <AuthenticationContext.Provider
      value={{
        authData,
        setAuthData,
        notificationCount,
        setNotificationCount,
        flooringCount,
        setFlooringCount,
      }}
    >
      <div className="App">
        <ToastContainer position="top-left" />
        <BrowserRouter basename="/dealer">
          <TokenHandler setCompLoad={setCompLoad} setAuthData={setAuthData} /> {/* ✅ FIXED */}
          <ScrollToTop />
          {compLoad || isLoading ? (
            <PageLoader />
          ) : (
            <Routes>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <DashboardLayout />
                  </AuthRoute>
                }
              >
                <Route
                  index
                  element={
                    <AuthRoute>
                      <Dashboard />
                    </AuthRoute>
                  }
                />
                <Route
                  path="/loan-products"
                  element={
                    <ProtectedRoute>
                      <LoanProduct />
                    </ProtectedRoute>
                  }
                />
                <Route path="/loan-products/:prodId/:year" element={<SingleLoanProduct />} />
                <Route
                  path="/loan-application"
                  element={
                    <ProtectedRoute>
                      <LoanAppl />
                    </ProtectedRoute>
                  }
                />
                <Route path="/loan-apply/:loanId/:singpassId?" element={<LoanApply />} />
                <Route
                  path="/case-list"
                  element={
                    <ProtectedRoute>
                      <CaseList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/case-detail"
                  element={
                    <ProtectedRoute>
                      <CaseDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/details-edit"
                  element={
                    <ProtectedRoute>
                      <EditDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/view-application"
                  element={
                    <ProtectedRoute>
                      <ViewApplicationForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/case-summary"
                  element={
                    <ProtectedRoute>
                      <CaseSumary />
                    </ProtectedRoute>
                  }
                />
                <Route path="/case-summary-info/:appId" element={<CaseSummaryInfo />} />
                <Route
                  path="/notification/application_updates"
                  element={
                    <ProtectedRoute>
                      <NotificationLayout />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/generated-invoice"
                  element={
                    <InvoiceGenerate />
                  }
                />
                <Route
                  path="/view-agent-chart"
                  element={
                    <AgentChart />
                  }
                />
                <Route
                  path="/notification/flooring_updates"
                  element={
                    <ProtectedRoute>
                      <FlooringNotificationLayout />
                    </ProtectedRoute>
                  }
                />
                <Route path="/flooring-cases/view/viewSOA" element={<ViewSOA />} />
                <Route
                  path="user-accounts"
                  element={
                    <ProtectedRoute>
                      <UserAccounts />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="user-roles"
                  element={
                    <ProtectedRoute>
                      <UserRoles />
                    </ProtectedRoute>
                  }
                />
                <Route path="flooring-rates" element={<FlooringRates />} />
                <Route path="flooring-voucher" element={<FlooringVouchers />} />
                <Route path="flooring-cases" element={<FlooringCases />} />
                <Route path="/flooring-cases/view" element={<ViewFlooringCases />} />
                <Route path="/flooring-cases/view/summary" element={<CaseSummary />} />
                <Route path="/flooring-cases/view/issueAAF" element={<PreviewAAF />} />
                <Route path="new-flooring-application" element={<NewFlooringApplication />} />
                <Route path="/accounts/profile" element={<Profile />} />
                <Route path="/no-permission" element={<NoPermission />} />
                <Route path="/dealer-commision-report" element={<DealerCommisionReport />} />
              </Route>

              <Route path="/remote-sign" element={<RemoteSign />} />
              <Route path="/login" element={<Login />} />
              <Route path="/resetpassword/:id" element={<ResetPassword />} />
            </Routes>
          )}
        </BrowserRouter>
      </div>
    </AuthenticationContext.Provider>
  );
}

export default App;
